import { observable, action, computed, makeObservable } from 'mobx';
import { http } from '../../helpers/HttpApi';
import { Brand } from 'helpers/constants/Brands';

export class RegisterModel {
    constructor() {
        makeObservable(this);
    }

    @observable
    public type: string = 'KIOSK_FIXEDPAYMENT';
    @observable
    public registerName!: string;
    @observable
    public isActive: boolean = true;
    @observable
    public registerId: number | null;
    @observable
    public locationId!: number;
    @observable
    public kioskId!: string;
    @observable
    public kioskName!: string;
    @observable
    public brand!: Brand;

    @action
    setValue(value: any) {
        Object.assign(this, value);
    }

    @action
    async createRegister() {
        var result = await http.post(
            `/api/locations/${this.locationId}/cash-registers/${this.registerId}/`,
            this
        );

        this.setValue(result.data);
    }

    @computed get status() {
        return this.isActive ? 'Enabled' : 'Disabled';
    }
}
